import React from 'react'
import styled, { css } from 'styled-components'

import { useHapticFeedback } from '@blade/ui-kit'
import { mediaMinTablet } from '@root/shared/ui-kit'

import { PoolCardAddress } from './pool-card-address'
import { PoolCardMainInfo } from './pool-card-main-info'
import { PoolCardMetricsSection } from './pool-card-metrics'

import type { PairModel } from '@root/entities/pair'

export type PoolCardProps = {
  pool: PairModel
  active?: boolean
  onClick?: (pool: PairModel) => void
}

export const PoolCard: React.FC<PoolCardProps> = ({
  pool,
  active = false,
  onClick,
}) => {
  const haptics = useHapticFeedback()

  return (
    <Root
      $active={active}
      onClick={() => {
        if (onClick) {
          haptics.impactOccurred('light')
          onClick(pool)
        }
      }}
    >
      <PoolCardMainInfo pool={pool} />
      <PoolCardMetricsSection pool={pool} />
      <PoolCardAddress pool={pool} />
    </Root>
  )
}

const Root = styled.div<{ $active: boolean }>`
  --card-separator-color: #242424;

  ${mediaMinTablet(css`
    --card-separator-color: var(--text-4);
  `)}

  display: grid;
  cursor: pointer;
  border-radius: 10px;
  transition: background 0.15s linear;

  ${({ $active }) => {
    if ($active) {
      return css`
        border: 1px solid var(--backgroundA-6);
        background:
          linear-gradient(
            284deg,
            rgba(77, 243, 51, 0) 2.62%,
            rgba(41, 193, 89, 0.04) 94.69%
          ),
          rgba(255, 255, 255, 0.04);
      `
    }

    return css`
      border: 1px solid var(--backgroundA-2);
      background: var(--backgroundA-2);
      &:hover {
        background: var(--backgroundA-3);
      }
    `
  }}
`
